export default "__VITE_ASSET__8a7fc0b9__"